import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PageContainer, PageHeader } from "@/components/layout/page";
import { PageTabs } from "@/components/nav/tabbed-page";

export const Route = createFileRoute("/_app/data-quality")({
  component: DataQualityLayout,
});

function DataQualityLayout() {
  return (
    <PageContainer>
      <PageHeader
        title="Data Quality"
        description="Reusable validation rule sets and PII masking policies."
      />
      <PageTabs
        tabs={[
          { label: "Rule Sets", to: "/data-quality/rules" },
          { label: "PII Masking", to: "/data-quality/pii" },
        ]}
      />
      <Outlet />
    </PageContainer>
  );
}
